import React, { useState } from 'react';

import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';
import type { SavedTourist } from 'src/routes/Checkout/store/client/types';
import type { DocType } from '../../types';
import MobileMenu from '../../Fields/TouristNameField/components/MobileMenu';

import styles from './showSavedTouristButton.module.css';

type Props = {
  docType: DocType;
  onClickOption: () => void;
  tourists: SavedTourist[];
};

const MobileSavedTourists = ({ onClickOption, docType, tourists }: Props) => {
  const [showMenu, setShowMenu] = useState(false);

  const { t } = useTranslation();

  if (!tourists?.length) return null;

  return (
    <>
      <Button
        functional
        className={styles.button}
        onClick={() => setShowMenu(true)}
      >
        {t('checkout.touristForm.name.chooseSavedTourist')}
      </Button>
      <MobileMenu
        tourists={tourists}
        docType={docType}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        onClickOption={onClickOption}
      />
    </>
  );
};

export default MobileSavedTourists;
